/**
 * Storage S3 + quotas (rodada 3b) — formatação de bytes em pt-BR.
 *
 * Util único para as 4 telas (integrações S3, planos, gerenciador de disco,
 * armazenamento do escritório). Diferente do `formatBytes` de
 * `assistant-attachments.ts` (ponto decimal, sem GB, escopo de anexos do
 * chat) — este cobre até GB e usa vírgula decimal (pt-BR), consistente com
 * o resto da copy do sistema.
 */

const UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/** Formata um número de bytes como "512 B", "3,4 MB", "1,00 GB" etc (pt-BR). */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes < 1024) return `${Math.round(bytes)} B`;

  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const decimals = unitIndex === 1 ? 0 : 1; // KB sem casa decimal, MB/GB com 1
  const formatted = value.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${formatted} ${UNITS[unitIndex]}`;
}

/** Converte GB (aceita decimal, ex: 0,5) para bytes inteiros. */
export function gbToBytes(gb: number): number {
  return Math.round(gb * 1024 * 1024 * 1024);
}

/** Converte bytes para GB (numero puro, para preencher input). */
export function bytesToGb(bytes: number): number {
  return bytes / (1024 * 1024 * 1024);
}

/** "10 GB" ou "Sem limite" (null) — usado na coluna quota das tabelas de plano/tenant. */
export function formatQuota(bytes: number | null): string {
  if (bytes === null) return 'Sem limite';
  return formatBytes(bytes);
}
